module.exports = __webpack_public_path__ + "static/media/pharmacore-paragon-white.34e7d6bc.png";